(ns kyber.components.composite.image-viewer
  (:require [kyber.components.composite.resource :as resource-component]
            [kyber.styles.core :refer [styles->classes]]))

(def classes
  (styles->classes
   {:image-viewer-container
    {:width "100%"
     :height "100%"
     :overflow-y :auto
     :display :flex}}))

(defn render [resource _]
  [:div {:class (:image-viewer-container classes)}
   [resource-component/resource
    {:tag   :img
     :src   (or (:url resource)
                (:resource/url resource))
     :alt   (or (:name resource)
                (:resource/name resource))
     :class (or (:img-class resource)
                (:resource/img-class resource))
     :style {:margin "auto"}}]])
